import { match } from "react-router-dom";
import BatchOperationsArchive from "@/modules/pg/plan/batchOperations/BatchOperationsArchive";

type Props = {
    match: match<{ group_uuid?: string }>;
};

function BatchOperationsArchiveStandalone(props: Props) {
    return <BatchOperationsArchive match={props.match} showHeader={true} />;
}

export default BatchOperationsArchiveStandalone;
